var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandScreen = function SvgExpandScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M5.829 10.172a.5.5 0 0 0-.707 0l-4.097 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.733l4.096-4.096a.5.5 0 0 0 0-.707M10.172 5.828a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 0 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707",
    clipRule: "evenodd"
  })));
};
export default SvgExpandScreen;